import React, { useEffect, useState, useRef, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import {
    GetStudentAnnualForm,
    UpdateAnnualForm,
    GetMatter,
    createAnnualFrom,
    getSchoolYear,
    DeleteAnnualForm,
    fetchLogo
} from '../../Api'
import LoadingSpinner from '../../components/Loading'
import {
    FichaContainer,
    FichaWrapper,
    FichaHeader,
    //FichaPrefeitura,
    FichaSecretaria,
    FichaNomeEscola,
    FichaTitleBox,
    FichaMunicipioBox,
    FieldRow,
    FieldBlock,
    FieldLabel,
    FieldUnderline,
    FichaTable,
    TableScroll,
    PeriodWarning,
    PeriodWarningIcon,
    PeriodWarningContent,
    PeriodWarningTitle,
    PeriodWarningText,
    PrintButton,
    YearSelectorWrapper,
    YearSelectorLabel,
    YearSelect,
    FichaSignatures,
    SignRow,
    SignBlock,
    SignLine,
    SignLabel,
    MunicipioDateRow,
    FichaGlobalPrint,
    Brasao,
    HeaderCenter,
    Overlay,
    Modal,
    EditModal,
    Section,
    SectionTitle,
    FormGrid,
    FullWidth,
    Input,
    Select,
    PeriodCard,
    PeriodTitle,
    SubLabel,
    FreqStrip,
    FreqItem,
    FreqLabel,
    Actions,
    Button,
    TextArea,
    SummaryBox,
    SummaryLabel,
    SummaryText,
} from './style'

/* ============================================
   FUNÇÕES AUXILIARES
============================================ */

function existePeriodo(rc) {
    console.log('TESTANDO RC', rc)

    if (!rc) return false

    const quarter =
        rc.id_iStQuarter ||
        rc.id_iiNdQuarter ||
        rc.id_iiiRdQuarter ||
        rc.id_ivThQuarter

    console.log('QUARTER', quarter)

    const temPeriodo = !!quarter

    const temDias = getDiasLetivos(rc) > 0

    const temFreq =
        rc?.frequencia &&
        (
            Number(rc.frequencia.totalFaltas || 0) > 0 ||
            Number(rc.frequencia.totalPresencas || 0) > 0 ||
            Number(rc.frequencia.totalFaltasJustificadas || 0) > 0
        )

    const temNota =
        rc?.studentGrade &&
        Object.values(rc.studentGrade).some(
            g =>
                g?.total !== '' &&
                g?.total !== null &&
                g?.total !== undefined
        )

    console.log({
        temPeriodo,
        temDias,
        temFreq,
        temNota
    })

    return temPeriodo || temDias || temFreq || temNota
}

function temTodasNotas(reportCard, subject, totalPeriodos) {
    if (!reportCard || !reportCard.length) return false

    const notas = reportCard
        .slice(0, totalPeriodos)
        .map(rc => {
            const key = Object.keys(rc?.studentGrade || {}).find(
                k => norm(k) === norm(subject)
            )
            return key ? rc.studentGrade[key]?.total : ''
        })

    return notas.every(n => n !== '' && n !== null && n !== undefined)
}

function norm(name) {
    return name?.trim().toUpperCase() || ''
}

function getGrade(studentGrade, subject) {
    if (!studentGrade) return ''
    const key = Object.keys(studentGrade).find(k => norm(k) === norm(subject))
    return key ? (studentGrade[key]?.total ?? '') : ''
}

function getDiasLetivos(rc) {
    if (!rc) return 0 // 🔥 ESSENCIAL

    const quarter =
        rc.id_iStQuarter ||
        rc.id_iiNdQuarter ||
        rc.id_iiiRdQuarter ||
        rc.id_ivThQuarter

    return quarter?.schoolDays?.length || 0
}

// Converte horas (número, pode ter fração) para o formato HH:MM — ex.: 202.5 → "202:30"
function formatHoras(valor) {
    if (valor === '' || valor === null || valor === undefined) return ''
    const n = Number(valor)
    if (!Number.isFinite(n)) return ''
    const totalMin = Math.round(n * 60)
    const h = Math.floor(totalMin / 60)
    const m = totalMin % 60
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
}

// Lê o que foi digitado ("800:00", "800:30", "800" ou "800,5") e devolve horas em número.
// Retorna null quando está vazio ou inválido.
function parseHoras(valor) {
    if (valor === '' || valor === null || valor === undefined) return null
    const txt = String(valor).trim()
    if (!txt) return null
    const m = txt.match(/^(\d+)\s*:\s*(\d{1,2})$/)
    if (m) return Number(m[1]) + Math.min(Number(m[2]), 59) / 60
    const n = Number(txt.replace(',', '.'))
    return Number.isFinite(n) ? n : null
}

function calcCargaPeriodo(rc, dailyWorkload) {
    if (!rc) return '' // 🔥 NÃO EXISTE DADO

    const dias = getDiasLetivos(rc)

    if (dias === 0 && !rc.id_iStQuarter && !rc.id_iiNdQuarter && !rc.id_iiiRdQuarter && !rc.id_ivThQuarter) {
        return '' // 🔥 NÃO EXISTE BOLETIM
    }

    return dias * Number(dailyWorkload || 0) // pode retornar 0
}
/*
function calcCargaPeriodo(freq, dailyWorkload) {
    if (!freq) return null
    const total =
        (Number(freq.totalPresencas || 0) +
            Number(freq.totalFaltas || 0) +
            Number(freq.totalFaltasJustificadas || 0)) *
        Number(dailyWorkload || 0)
    return total
}*/

function calcFaltasPeriodo(freq, dailyWorkload, rc) {
    if (!rc) return '' // 🔥 não existe período

    const dias = getDiasLetivos(rc)

    // 🔥 NÃO EXISTE BOLETIM
    if (
        dias === 0 &&
        !rc.id_iStQuarter &&
        !rc.id_iiNdQuarter &&
        !rc.id_iiiRdQuarter &&
        !rc.id_ivThQuarter
    ) {
        return ''
    }

    if (!freq) return ''

    const total =
        (Number(freq.totalFaltas || 0) +
            Number(freq.totalFaltasJustificadas || 0)) *
        Number(dailyWorkload || 0)

    return total
}

// Soma as notas da matéria nos períodos que JÁ têm nota (mesmo que faltem períodos).
// Retorna '' se nenhum período tiver nota.
function somaNotasDisponiveis(reportCard = [], subject, totalPeriodos) {
    const valores = reportCard
        .slice(0, totalPeriodos)
        .map(rc => {
            const key = Object.keys(rc?.studentGrade || {}).find(k => norm(k) === norm(subject))
            const v = key ? rc.studentGrade[key]?.total : ''
            if (v === '' || v === null || v === undefined) return null
            const n = Number(String(v).replace(',', '.'))
            return Number.isFinite(n) ? n : null
        })
        .filter(n => n !== null)

    if (!valores.length) return ''
    const soma = valores.reduce((acc, n) => acc + n, 0)
    return String(Math.round(soma * 100) / 100).replace('.', ',')
}

// Valor manual do total geral da matéria (procura sem diferenciar maiúsculas/espaços)
function notaManual(manual, subject) {
    if (!manual) return ''
    const key = Object.keys(manual).find(k => norm(k) === norm(subject))
    const v = key ? manual[key] : ''
    return v === null || v === undefined ? '' : String(v).trim()
}

function notaFinal(reportCard = [], subject, totalPeriodos) {
    if (!temTodasNotas(reportCard, subject, totalPeriodos)) return ''

    const values = reportCard
        .slice(0, totalPeriodos)
        .map(rc => {
            const key = Object.keys(rc?.studentGrade || {}).find(
                k => norm(k) === norm(subject)
            )
            return Number(rc.studentGrade[key]?.total)
        })

    return values.reduce((acc, n) => acc + n, 0)
}

// Total de linhas do tbody:
// períodos: TOTAL_PERIODOS × 3 linhas cada
// total geral: 3 linhas
// recuperação final: 3 linhas

/* ============================================
   FIELD — fora do componente principal para
   evitar remount a cada keystroke
============================================ */
const Field = ({ label, children }) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <label style={{ fontSize: 12, fontWeight: 600, color: 'var(--text, var(--text-muted))' }}>
            {label}
        </label>
        {children}
    </div>
)

/* ============================================
   COMPONENTE PRINCIPAL
============================================ */
const FichaIndividual = () => {
    const { id_student } = useParams()

    const [history, setHistory] = useState([])
    const [loading, setLoading] = useState(true)
    const [selectedYear, setSelectedYear] = useState(String(new Date().getFullYear()))

    const [isEditing, setIsEditing] = useState(false)
    const [editData, setEditData] = useState(null)
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
    const [deleting, setDeleting] = useState(false)

    const [generateYear, setGenerateYear] = useState(String(new Date().getFullYear()))
    const [loadingGenerate, setLoadingGenerate] = useState(false)
    const [schoolYear, setSchoolYear] = useState(String(new Date().getFullYear()))

    const [matters, setMatter] = useState([])
    const [logoUrl, setLogoUrl] = useState('')
    const fichaRef = useRef(null)

    const [showEmptyWarning, setShowEmptyWarning] = useState(false)

    const [alreadySeenWarning, setAlreadySeenWarning] = useState(false)

    //const [assessmentRegime, setAssessmentRegime] = useState('');

    useEffect(() => {
        async function loadData() {
            try {
                const idSchool = sessionStorage.getItem("id-school");

                const [res, yearRes, matterRes] = await Promise.all([
                    GetStudentAnnualForm(id_student),
                    getSchoolYear(JSON.parse(idSchool)),
                    GetMatter(JSON.parse(idSchool)),
                ])

                // ── histórico ──
                const data = Array.isArray(res.data)
                    ? res.data
                    : Array.isArray(res.data?.data)
                        ? res.data.data
                        : []

                const getSerieNumber = s => {
                    if (!s) return 0
                    const m = s.match(/\d+/)
                    return m ? Number(m[0]) : 0
                }
                const sorted = [...data].sort(
                    (a, b) => getSerieNumber(a.serie) - getSerieNumber(b.serie)
                )
                setHistory(sorted)

                // ── ano letivo atual da escola ──
                const currentSchoolYear = String(yearRes?.data?.data || new Date().getFullYear())
                setSchoolYear(currentSchoolYear)
                setGenerateYear(currentSchoolYear)

                // Inicializa no ano letivo atual se existir; senão no mais recente
                const hasCurrentYear = sorted.some(h => h.year === currentSchoolYear)
                if (hasCurrentYear) {
                    setSelectedYear(currentSchoolYear)
                } else if (sorted.length > 0) {
                    setSelectedYear(sorted[sorted.length - 1].year)
                } else {
                    setSelectedYear(currentSchoolYear)
                }

                // ── matérias (na ordem definida pelo usuário, vinda do backend) ──
                // O backend já retorna ordenado pelo campo `order`. Não reordenamos
                // por createdAt/_id para não sobrescrever a ordem manual do usuário.
                // Apenas garantimos a Educação Física sempre no final.
                const EF_NAME = 'EDUCAÇÃO FÍSICA'
                const rawMatters = matterRes.data.data || []
                const orderedMatters = [...rawMatters].sort((a, b) => {
                    const aEF = norm(a.name) === EF_NAME
                    const bEF = norm(b.name) === EF_NAME
                    if (aEF) return 1
                    if (bEF) return -1
                    return 0 // mantém a ordem do backend (ordem do usuário)
                })
                setMatter(orderedMatters)

                // ── logo da escola (mesma lógica/cache do boletim) ──
                const idSchoolParsed = JSON.parse(idSchool)
                const cachedLogo = localStorage.getItem(`school-logo-${idSchoolParsed}`)
                if (cachedLogo) {
                    setLogoUrl(cachedLogo)
                } else {
                    try {
                        const logoRes = await fetchLogo(idSchoolParsed)
                        if (logoRes?.url) {
                            setLogoUrl(logoRes.url)
                            localStorage.setItem(`school-logo-${idSchoolParsed}`, logoRes.url)
                            if (logoRes._id) {
                                localStorage.setItem(`school-logo-id-${idSchoolParsed}`, logoRes._id)
                            }
                        }
                    } catch (logoErr) {
                        console.error('Erro ao buscar logo:', logoErr)
                    }
                }

            } catch (err) {
                console.error(err)
                setHistory([])
            } finally {
                setLoading(false)
            }
        }
        loadData()
    }, [id_student])

    /* ---------- dados do ano selecionado ---------- */
    const yearData = history.find(h => h.year === selectedYear) || history[0]

    const naoTemNenhumBoletim = useMemo(() => {
        console.log('REPORT CARD:', yearData?.reportCard)

        if (!yearData?.reportCard?.length) {
            console.log('SEM REPORTCARD')
            return true
        }

        const result = !yearData.reportCard.some(rc => {
            const existe = existePeriodo(rc)

            console.log('RC:', rc)
            console.log('EXISTE?', existe)

            return existe
        })

        console.log('RESULTADO FINAL:', result)

        return result
    }, [yearData])

    useEffect(() => {
        if (loading) return

        const isCurrentYear = selectedYear === schoolYear

        // abre
        if (
            naoTemNenhumBoletim &&
            !alreadySeenWarning &&
            isCurrentYear
        ) {
            setShowEmptyWarning(true)
            setAlreadySeenWarning(true)
        }

        // fecha automaticamente quando aparecer dado
        if (!naoTemNenhumBoletim) {
            setShowEmptyWarning(false)
        }

    }, [
        loading,
        naoTemNenhumBoletim,
        alreadySeenWarning,
        selectedYear,
        schoolYear
    ])

    console.log('matters', matters)

    const sortedReportCard = useMemo(() => {
        return [...(editData?.reportCard || [])].sort((a, b) => {
            const nA = Number(a.bimonthly?.match(/\d+/)?.[0] || 0)
            const nB = Number(b.bimonthly?.match(/\d+/)?.[0] || 0)
            return nA - nB
        })
    }, [editData?.reportCard])

    const assessmentRegime = useMemo(() => {
        if (!yearData) return 'BIMESTRAL'

        const reportCard = yearData.reportCard || []

        if (reportCard.length === 0) {
            return (sessionStorage.getItem('assessmentRegime') || 'BIMESTRAL').toUpperCase()
        }

        const firstPeriod = reportCard.find(rc =>
            rc.bimonthly?.includes('1º')
        )

        const regime = firstPeriod?.id_iStQuarter?.assessmentRegime

        return (regime || 'BIMESTRAL').toUpperCase()
    }, [yearData])

    const isTrimestral = assessmentRegime === 'TRIMESTRAL'
    const TOTAL_PERIODOS = isTrimestral ? 3 : 4

    const TOTAL_BODY_ROWS = TOTAL_PERIODOS * 3 + 3 + 3  // = 18

    // Nome do período conforme o regime da escola ("1º BIMESTRE" → "1º TRIMESTRE")
    const nomePeriodo = (nome = '') =>
        isTrimestral ? String(nome).replace(/BIMESTRE/gi, 'TRIMESTRE') : nome

    // Na edição mostra só os períodos do regime (3 no trimestral, 4 no bimestral)
    const periodosEdicao = sortedReportCard.filter(rc => {
        const n = Number(rc.bimonthly?.match(/\d+/)?.[0] || 0)
        return n === 0 || n <= TOTAL_PERIODOS
    })

    if (loading)
        return (
            <FichaContainer style={{ width: '100%' }}>
                <LoadingSpinner />
            </FichaContainer>
        )

    if (!history.length) {
        const currentYear = new Date().getFullYear()
        const yearOptions = Array.from({ length: 7 }, (_, i) => currentYear - i)

        const handleGenerate = async () => {
            if (!generateYear) {
                alert('Selecione o ano letivo.')
                return
            }
            const idSchool = JSON.parse(sessionStorage.getItem('id-school'))
            if (!idSchool) {
                alert('Escola não identificada. Tente novamente.')
                return
            }
            try {
                setLoadingGenerate(true)
                await createAnnualFrom(idSchool, generateYear, id_student)
                alert('Ficha gerada com sucesso!')
                window.location.reload()
            } catch (err) {
                console.error(err)
                alert('Erro ao gerar a ficha.')
            } finally {
                setLoadingGenerate(false)
            }
        }

        return (
            <FichaContainer>
                <div style={{
                    maxWidth: 480,
                    margin: '60px auto',
                    background: 'var(--surface)',
                    borderRadius: 12,
                    padding: '36px 32px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.10)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 20,
                    textAlign: 'center',
                }}>
                    <div style={{ fontSize: 48 }}>📄</div>

                    <div>
                        <h2 style={{ margin: '0 0 8px', fontSize: 20, color: 'var(--text, var(--text-muted))' }}>
                            Nenhuma ficha encontrada
                        </h2>
                        <p style={{ margin: 0, fontSize: 14, color: 'var(--text, var(--text-muted))' }}>
                            Este aluno ainda não possui ficha individual.
                            Selecione o ano letivo e clique em <strong>Gerar Ficha</strong> para criá-la.
                        </p>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, width: '100%' }}>
                        <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--text, var(--text-muted))', textAlign: 'left' }}>
                            Ano Letivo
                        </label>
                        <YearSelect
                            value={generateYear}
                            onChange={e => setGenerateYear(e.target.value)}
                            style={{ width: '100%' }}
                        >
                            {yearOptions.map(y => (
                                <option key={y} value={String(y)}>{y}</option>
                            ))}
                        </YearSelect>
                    </div>

                    <PrintButton
                        onClick={handleGenerate}
                        disabled={loadingGenerate}
                        style={{
                            width: '100%',
                            padding: '12px',
                            fontSize: 15,
                            opacity: loadingGenerate ? 0.7 : 1,
                            cursor: loadingGenerate ? 'not-allowed' : 'pointer',
                        }}
                    >
                        {loadingGenerate ? '⏳ Gerando...' : '📋 Gerar Ficha Individual'}
                    </PrintButton>
                </div>
            </FichaContainer>
        )
    }

    const reportCard = [...(yearData?.reportCard || [])].sort((a, b) => {
        const nA = Number(a.bimonthly?.match(/\d+/)?.[0] || 0)
        const nB = Number(b.bimonthly?.match(/\d+/)?.[0] || 0)
        return nA - nB
    })

    const subjects = matters.map(m => m.name.trim())
    const numSubjects = subjects.length
    const mergedColSpan = numSubjects + 1   // matérias + parte diversificada

    const dailyWorkload = yearData?.dailyWorkload || 0

    // Dias letivos vêm direto do cadastro do ano (annualSchoolDays salvo no documento).
    // CH anual = dias letivos × carga horária diária. Ambos sempre exibidos.
    const annualSchoolDaysSaved = yearData?.annualSchoolDays || ''

    const diasLetivosExibir = annualSchoolDaysSaved !== ''
        ? Number(annualSchoolDaysSaved)
        : ''

    const cargaHorariaAnual = annualSchoolDaysSaved !== ''
        ? Number(annualSchoolDaysSaved) * Number(dailyWorkload)
        : ''

    // Soma apenas os períodos que possuem dados registrados, independentemente
    // de quantos forem. Assim o total geral aparece mesmo com só um período.
    const periodosComDados = reportCard
        .slice(0, TOTAL_PERIODOS)
        .filter(rc => existePeriodo(rc))

    // faltam períodos? (menos períodos com dados do que o total do regime)
    const faltamPeriodos = periodosComDados.length < TOTAL_PERIODOS
    const periodosFaltando = TOTAL_PERIODOS - periodosComDados.length

    // Total geral automático: só quando TODOS os bimestres/trimestres estão
    // completos — soma a carga horária / faltas dos períodos.
    const periodosCompletos = periodosComDados.length >= TOTAL_PERIODOS

    const totalCargaHorariaAuto = periodosCompletos
        ? periodosComDados
            .reduce((acc, rc) => acc + (Number(calcCargaPeriodo(rc, dailyWorkload)) || 0), 0)
        : ''

    const totalFaltasHorasAuto = periodosCompletos
        ? periodosComDados
            .reduce((acc, rc) => acc + (Number(calcFaltasPeriodo(rc.frequencia, dailyWorkload, rc)) || 0), 0)
        : ''

    // Valor digitado na edição da ficha tem prioridade; vazio → automático
    // (que fica em branco se faltar algum período).
    const totalCargaHorariaManual = parseHoras(yearData?.totalWorkloadManual)
    const totalFaltasHorasManual = parseHoras(yearData?.totalAbsencesManual)

    const totalCargaHoraria = totalCargaHorariaManual !== null ? totalCargaHorariaManual : totalCargaHorariaAuto
    const totalFaltasHoras = totalFaltasHorasManual !== null ? totalFaltasHorasManual : totalFaltasHorasAuto
    function setDiasLetivos(rc, quantidade) {
        const quarter =
            rc.id_iStQuarter ||
            rc.id_iiNdQuarter ||
            rc.id_iiiRdQuarter ||
            rc.id_ivThQuarter

        if (!quarter) return

        quarter.schoolDays = Array.from({ length: Number(quantidade) }, (_, i) => ({
            date: new Date(), // pode melhorar depois
            _id: i
        }))
    }

    const handlePrint = () => {
        document.body.classList.add('print-ficha')
        window.print()
        document.body.classList.remove('print-ficha')
    }

    const handleDelete = async () => {
        if (!yearData?._id) return
        try {
            setDeleting(true)
            await DeleteAnnualForm(yearData._id)
            setShowDeleteConfirm(false)

            // recarrega os dados sem reload bruto
            const res = await GetStudentAnnualForm(id_student)
            setHistory(res.data)
        } catch (err) {
            console.error(err)
            alert('Erro ao apagar ficha')
        } finally {
            setDeleting(false)
        }
    }

    /*function temTodosPeriodos(reportCard, totalPeriodos) {
        if (!reportCard || reportCard.length < totalPeriodos) return false

        return reportCard
            .slice(0, totalPeriodos)
            .every(rc => existePeriodo(rc))
    }*/

    // Extrai apenas a parte de data (YYYY-MM-DD) de qualquer entrada,
    // sem criar objeto Date (evita o deslocamento de fuso horário).
    function toDateParts(value) {
        if (!value) return null;

        // Date object
        if (value instanceof Date && !isNaN(value)) {
            return {
                year: String(value.getFullYear()),
                month: String(value.getMonth() + 1).padStart(2, "0"),
                day: String(value.getDate()).padStart(2, "0"),
            };
        }

        const str = String(value).trim();

        // ISO com hora: 2024-01-22T00:00:00.000Z → pega só a data
        const isoMatch = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (isoMatch) {
            const [, year, month, day] = isoMatch;
            return { year, month, day };
        }

        // DD/MM/YYYY
        const ptMatch = str.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
        if (ptMatch) {
            const [, day, month, year] = ptMatch;
            return { year, month, day };
        }

        // DD-MM-YYYY
        const ptDashMatch = str.match(/^(\d{2})-(\d{2})-(\d{4})$/);
        if (ptDashMatch) {
            const [, day, month, year] = ptDashMatch;
            return { year, month, day };
        }

        return null;
    }

    // Exibição pt-BR (DD/MM/YYYY). Mantém o que o usuário digita enquanto incompleto.
    function formatDatePtBr(value) {
        if (!value) return "";
        const parts = toDateParts(value);
        if (!parts) return String(value); // usuário ainda está digitando
        return `${parts.day}/${parts.month}/${parts.year}`;
    }

    // Converte qualquer entrada para ISO (YYYY-MM-DD) para salvar no estado/back-end.
    function toIsoDate(value) {
        const parts = toDateParts(value);
        if (!parts) return value;
        return `${parts.year}-${parts.month}-${parts.day}`;
    }

    // Parse UTC-safe: monta a data ao meio-dia local para nunca cruzar o fuso.
    function parseDate(value) {
        const parts = toDateParts(value);
        if (!parts) return null;
        return new Date(
            Number(parts.year),
            Number(parts.month) - 1,
            Number(parts.day),
            12, 0, 0
        );
    }

    // Máscara de digitação pt-BR enquanto o usuário escreve no input.
    function maskDatePtBr(value) {
        const digits = String(value || "").replace(/\D/g, "").slice(0, 8);
        const parts = [];
        if (digits.length > 0) parts.push(digits.slice(0, 2));
        if (digits.length >= 3) parts.push(digits.slice(2, 4));
        if (digits.length >= 5) parts.push(digits.slice(4, 8));
        return parts.join("/");
    }

    /* ====================================================
       RENDER
    ==================================================== */
    return (
        <FichaContainer>
            <FichaGlobalPrint />

            {/* ---- CONTROLES ---- */}
            <YearSelectorWrapper className="no-print">
                <YearSelectorLabel>Selecionar ano:</YearSelectorLabel>
                <YearSelect
                    value={selectedYear}
                    onChange={e => setSelectedYear(e.target.value)}
                >
                    {(() => {
                        const historyYears = new Set(history.map(h => h.year))
                        const currentSchoolYearNum = Number(schoolYear)
                        const rangeYears = Array.from({ length: 7 }, (_, i) =>
                            String(currentSchoolYearNum - i)
                        )
                        const allYears = [...new Set([...rangeYears, ...historyYears])]
                            .sort((a, b) => Number(b) - Number(a))

                        return allYears.map(y => {
                            const hasData = historyYears.has(y)
                            const isCurrent = y === schoolYear
                            return (
                                <option key={y} value={y}>
                                    {y}
                                    {isCurrent ? ' (Ano Letivo Atual)' : ''}
                                    {!hasData ? ' — sem ficha' : ''}
                                </option>
                            )
                        })
                    })()}
                </YearSelect>

                {/* Ano sem ficha: botão para gerar */}
                {console.log('his', history)}
                {!history.find(h => h.year === selectedYear) && (
                    <PrintButton
                        onClick={async () => {
                            const idSchool = JSON.parse(sessionStorage.getItem('id-school'))
                            if (!idSchool) { alert('Escola não identificada.'); return }
                            try {
                                setLoadingGenerate(true)
                                await createAnnualFrom(idSchool, selectedYear, id_student)
                                alert('Ficha gerada com sucesso!')
                                window.location.reload()
                            } catch (err) {
                                console.error(err)
                                alert('Erro ao gerar a ficha.')
                            } finally {
                                setLoadingGenerate(false)
                            }
                        }}
                        disabled={loadingGenerate}
                        style={{ background: loadingGenerate ? '#aaa' : '#2e7d32' }}
                    >
                        {loadingGenerate ? '⏳ Gerando...' : '📋 Gerar Ficha'}
                    </PrintButton>
                )}

                {/* Ano com ficha: botões de imprimir e editar */}
                {history.find(h => h.year === selectedYear) && (
                    <>
                        <PrintButton onClick={handlePrint}>🖨️ Imprimir Ficha</PrintButton>
                        <PrintButton onClick={() => {
                            setEditData(JSON.parse(JSON.stringify(yearData)))
                            setIsEditing(true)
                        }}>
                            ✏️ Editar Ficha
                        </PrintButton>
                        <PrintButton
                            onClick={() => setShowDeleteConfirm(true)}
                            style={{ background: '#c62828' }}
                        >
                            🗑️ Apagar Ficha
                        </PrintButton>
                    </>
                )}
            </YearSelectorWrapper>

            {history.find(h => h.year === selectedYear) && (
                /* ---- FICHA ---- */
                <FichaWrapper ref={fichaRef} className="print-ficha-content">

                    {/* CABEÇALHO */}
                    <FichaHeader>
                        {logoUrl
                            ? <Brasao as="img" src={logoUrl} alt="Logo da escola" />
                            : <Brasao>🏛</Brasao>}
                        <HeaderCenter>
                            <FichaNomeEscola>
                                {yearData?.nameSchool}
                            </FichaNomeEscola>
                            {/*<FichaPrefeitura>
                                PREFEITURA MUNICIPAL DE{' '}
                                {yearData?.municipality?.toUpperCase()}
                            </FichaPrefeitura>*/}
                            <FichaSecretaria>
                                Secretaria Municipal De Educação
                            </FichaSecretaria>
                        </HeaderCenter>
                    </FichaHeader>

                    {/* TÍTULO */}
                    <FichaTitleBox>
                        FICHA INDIVIDUAL DO ALUNO ENSINO FUNDAMENTAL{' '}
                        {yearData?.year || '____'}
                    </FichaTitleBox>

                    {/* MUNICÍPIO */}
                    <FichaMunicipioBox>
                        {yearData?.municipality?.toUpperCase()} —{' '}
                        {yearData?.state?.toUpperCase()}
                    </FichaMunicipioBox>

                    {/* CAMPOS DO ALUNO */}
                    <FieldRow>
                        <FieldBlock flex="1">
                            <FieldLabel>Escola Municipal</FieldLabel>
                            <FieldUnderline>{yearData?.nameSchool}</FieldUnderline>
                        </FieldBlock>
                    </FieldRow>

                    <FieldRow>
                        <FieldBlock flex="1">
                            <FieldLabel>Nome do Aluno</FieldLabel>
                            <FieldUnderline>{yearData?.nameStudent}</FieldUnderline>
                        </FieldBlock>
                    </FieldRow>

                    <FieldRow>
                        <FieldBlock flex="1">
                            <FieldLabel>Endereço</FieldLabel>
                            <FieldUnderline>{yearData?.address}</FieldUnderline>
                        </FieldBlock>
                    </FieldRow>

                    <FieldRow style={{ alignItems: 'flex-end' }}>
                        <FieldBlock flex="1">
                            <FieldLabel>Filiação (Mãe)</FieldLabel>
                            <FieldUnderline>{yearData?.mothersName}</FieldUnderline>
                        </FieldBlock>
                        <span style={{
                            fontWeight: 'bold',
                            fontSize: '12px',
                            paddingBottom: '2px',
                            whiteSpace: 'nowrap',
                            lineHeight: 1,
                        }}>e</span>
                        <FieldBlock flex="1">
                            <FieldLabel>Pai</FieldLabel>
                            <FieldUnderline>{yearData?.fathersName}</FieldUnderline>
                        </FieldBlock>
                    </FieldRow>

                    <FieldRow>
                        <FieldBlock flex="1">
                            <FieldLabel>Data de Nasc.</FieldLabel>
                            <FieldUnderline>
                                {yearData?.birth
                                    ? parseDate(yearData.birth)?.toLocaleDateString("pt-BR") ?? ""
                                    : ''}
                            </FieldUnderline>
                        </FieldBlock>
                        <FieldBlock width="120px">
                            <FieldLabel>Sexo</FieldLabel>
                            <FieldUnderline >{yearData?.sexo}</FieldUnderline>
                        </FieldBlock>
                    </FieldRow>

                    <FieldRow>
                        <FieldBlock flex="1">
                            <FieldLabel>Nacionalidade</FieldLabel>
                            <FieldUnderline >{yearData?.nationality}</FieldUnderline>
                        </FieldBlock>
                        <FieldBlock flex="1">
                            <FieldLabel>Estado</FieldLabel>
                            <FieldUnderline>{yearData?.state}</FieldUnderline>
                        </FieldBlock>
                    </FieldRow>
                    <FieldRow>
                        <FieldBlock flex="1">
                            <FieldLabel>Naturalidade</FieldLabel>
                            <FieldUnderline >{yearData?.naturalness}</FieldUnderline>
                        </FieldBlock>
                    </FieldRow>

                    <FieldRow>
                        <FieldBlock flex="1">
                            <FieldLabel>Ano de Escolaridade / Série</FieldLabel>
                            <FieldUnderline>{yearData?.serie ?? yearData?.idClass?.serie}</FieldUnderline>
                        </FieldBlock>
                        <FieldBlock >
                            <FieldLabel>Turma</FieldLabel>
                            <FieldUnderline >{yearData?.nameClass ?? yearData?.idClass?.name}</FieldUnderline>
                        </FieldBlock>
                        <FieldBlock width="130px">
                            <FieldLabel>Turno</FieldLabel>
                            <FieldUnderline >{yearData?.shift ?? yearData?.idClass?.shift}</FieldUnderline>
                        </FieldBlock>
                    </FieldRow>
                    <FieldRow>
                        <FieldRow>
                            <FieldBlock flex="1">
                                <FieldLabel>Mínimo para promoção</FieldLabel>
                                <FieldUnderline >{yearData?.averageGrade}</FieldUnderline>
                            </FieldBlock>
                        </FieldRow>
                        <FieldBlock width="160px">
                            <FieldLabel>Dias Letivos Anuais</FieldLabel>
                            <FieldUnderline>{diasLetivosExibir}</FieldUnderline>
                        </FieldBlock>
                        <FieldBlock width="120px">
                            <FieldLabel>C.H. Anual</FieldLabel>
                            <FieldUnderline>
                                {formatHoras(cargaHorariaAnual)}
                            </FieldUnderline>
                        </FieldBlock>
                    </FieldRow>

                    {faltamPeriodos && (
                        <PeriodWarning className="no-print">
                            <PeriodWarningIcon>⚠️</PeriodWarningIcon>
                            <PeriodWarningContent>
                                <PeriodWarningTitle>
                                    {periodosComDados.length === 0
                                        ? 'Dados do aluno ainda não consolidados'
                                        : `Faltam ${periodosFaltando} ${isTrimestral ? 'trimestre' : 'bimestre'}${periodosFaltando > 1 ? 's' : ''} para consolidar todos os dados`}
                                </PeriodWarningTitle>
                                <PeriodWarningText>
                                    Para que os dados do aluno venham para a ficha individual, é necessário que o aluno esteja <strong>vinculado à turma</strong> e que os diários de <strong>todos os {isTrimestral ? 'trimestres' : 'bimestres'}</strong> sejam <strong>fechados</strong>. Assim que os diários forem fechados, a ficha individual será atualizada automaticamente com todos os dados do aluno. Depois disso, os diários podem ser reabertos, se necessário.
                                </PeriodWarningText>
                            </PeriodWarningContent>
                        </PeriodWarning>
                    )}

                    {/* ---- TABELA ---- */}
                    <TableScroll>
                        <FichaTable>
                            <thead>
                                {/* LINHA 1 */}
                                <tr>
                                    <th rowSpan={4} className="th-trimestre">
                                        {assessmentRegime === 'TRIMESTRAL' ? 'TRIMESTRE' : 'BIMESTRE'}
                                    </th>
                                    <th rowSpan={4} className="th-verif">
                                        VERIFICAÇÃO<br />DO<br />RENDIMENTO
                                    </th>
                                    {/* colspan = só matérias (sem Parte Diversificada) */}
                                    <th colSpan={numSubjects} className="th-group">
                                        ENSINO FUNDAMENTAL
                                    </th>
                                    <th rowSpan={4} className="th-situacao">
                                        SITUAÇÃO<br />DO<br />ALUNO
                                    </th>
                                    <th rowSpan={4} className="th-obs">
                                        OBSERVAÇÕES
                                    </th>
                                </tr>


                                {/* LINHA 3 */}
                                <tr>
                                    <th colSpan={numSubjects} className="th-group">
                                        ÁREAS DE CONHECIMENTO
                                    </th>
                                </tr>

                                {/* LINHA 4 — matérias do backend */}
                                <tr>
                                    {subjects.map(s => (
                                        <th key={s} className="th-subject">{s}</th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {/* ===== PERÍODOS ===== */}
                                {Array.from({ length: TOTAL_PERIODOS }).map((_, i) => {
                                    const rc = reportCard[i] || {}
                                    const freq = rc?.frequencia || {}
                                    const cargaP = calcCargaPeriodo(rc, dailyWorkload)
                                    const faltasP = calcFaltasPeriodo(freq, dailyWorkload, rc)
                                    const isFirst = i === 0

                                    return (
                                        <React.Fragment key={i}>

                                            {/* APROVEITAMENTO */}
                                            <tr>
                                                <td rowSpan={3} className="td-periodo">{i + 1}º</td>
                                                <td className="td-row-label">Aproveitamento</td>
                                                {subjects.map(s => (
                                                    <td key={s} className="td-grade">
                                                        {rc ? getGrade(rc.studentGrade, s) : ''}
                                                    </td>
                                                ))}
                                                {/* ❌ Removido: td Parte Diversificada */}

                                                {/* Situação — única célula, cobre todo o tbody */}
                                                {isFirst && (
                                                    <td
                                                        rowSpan={TOTAL_BODY_ROWS}
                                                        className="td-situacao-cell"
                                                    >
                                                        {yearData?.studentSituation}
                                                    </td>
                                                )}

                                                {/* Observações — única célula, cobre todo o tbody */}
                                                {isFirst && (
                                                    <td
                                                        rowSpan={TOTAL_BODY_ROWS}
                                                        className="td-obs-cell"
                                                    >
                                                        {(yearData?.observations || '').slice(0, 800)}
                                                    </td>
                                                )}
                                            </tr>

                                            {/* CARGA HORÁRIA */}
                                            <tr>
                                                <td className="td-row-label">Carga Horária</td>
                                                <td colSpan={mergedColSpan} className="td-merged-value">
                                                    {formatHoras(cargaP)}
                                                </td>
                                            </tr>

                                            {/* FALTAS */}
                                            <tr>
                                                <td className="td-row-label">Faltas</td>
                                                <td colSpan={mergedColSpan} className="td-merged-value">
                                                    {formatHoras(faltasP)}
                                                </td>
                                            </tr>

                                        </React.Fragment>
                                    )
                                })}

                                {/* ===== TOTAL GERAL ===== */}
                                <tr>
                                    <td rowSpan={3} className="td-periodo td-total-label">
                                        TOTAL<br />GERAL
                                    </td>
                                    <td className="td-row-label">Aproveitamento</td>
                                    {subjects.map(s => (
                                        <td key={s} className="td-grade">
                                            {/* manual (edição) tem prioridade; senão, automático só com todos os períodos */}
                                            {notaManual(yearData?.totalGradesManual, s) || notaFinal(reportCard, s, TOTAL_PERIODOS)}
                                        </td>
                                    ))}
                                </tr>

                                <tr>
                                    <td className="td-row-label">Carga Horária</td>
                                    <td colSpan={mergedColSpan} className="td-merged-value">
                                        {formatHoras(totalCargaHoraria)}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-row-label">Faltas (Horas)</td>
                                    <td colSpan={mergedColSpan} className="td-merged-value">
                                        {formatHoras(totalFaltasHoras)}
                                    </td>
                                </tr>

                                {/* ===== RECUPERAÇÃO FINAL ===== */}
                                <tr>
                                    <td rowSpan={3} className="td-periodo td-total-label">
                                        RECUPE-<br />RAÇÃO<br />FINAL
                                    </td>
                                    <td className="td-row-label">Aproveitamento</td>
                                    {subjects.map(s => {
                                        const rec = yearData.recovery?.find(r => norm(r.subject) === norm(s))
                                        return (
                                            <td key={s} className="td-grade">
                                                {rec?.grade || ''}
                                            </td>
                                        )
                                    })}
                                </tr>

                                <tr>
                                    <td className="td-row-label">Carga Horária</td>
                                    <td colSpan={mergedColSpan} className="td-merged-value">
                                        {formatHoras(yearData.recovery?.reduce((acc, r) => acc + Number(r.workload || 0), 0) ?? '')}
                                    </td>
                                </tr>

                                <tr>
                                    <td className="td-row-label">Faltas (Horas)</td>
                                    <td colSpan={mergedColSpan} className="td-merged-value">
                                        {formatHoras(yearData.recovery?.reduce((acc, r) => acc + Number(r.absences || 0), 0) ?? '')}
                                    </td>
                                </tr>

                            </tbody>
                        </FichaTable>
                    </TableScroll>

                    {/* SÍNTESE DO PROFESSOR */}
                    <SummaryBox>
                        <SummaryLabel>Síntese do professor sobre os avanços e as dificuldades do aluno:</SummaryLabel>
                        <SummaryText>
                            {yearData?.teachersSummaryOfTheStudent || ''}
                        </SummaryText>
                    </SummaryBox>

                    {/* ASSINATURAS */}
                    <FichaSignatures>
                        <SignRow>
                            <SignBlock>
                                <SignLine />
                                <SignLabel>
                                    ASSINATURA DO(A) SECRETÁRIO(A) - N.º REG. OU AUT.
                                </SignLabel>
                            </SignBlock>
                            <SignBlock>
                                <SignLine />
                                <SignLabel>
                                    ASSINATURA DO(A) DIRETOR(A) - N.º REG. OU AUT.
                                </SignLabel>
                            </SignBlock>
                        </SignRow>
                        <MunicipioDateRow>
                            <SignBlock style={{ maxWidth: '50%' }}>
                                <SignLine />
                                <SignLabel>MUNICÍPIO E DATA DE EXPEDIÇÃO</SignLabel>
                            </SignBlock>
                        </MunicipioDateRow>
                    </FichaSignatures>

                </FichaWrapper>
            )}
            {isEditing && (
                <Overlay onClick={() => setIsEditing(false)}>
                    <EditModal onClick={(e) => e.stopPropagation()}>

                        <h2>Editar Ficha</h2>

                        {/* ===== DADOS DO ALUNO ===== */}
                        <Section>
                            <SectionTitle>Dados do Aluno</SectionTitle>

                            <FormGrid>

                                <Field label="Nome do Aluno">
                                    <Input
                                        value={editData.nameStudent ?? ''}
                                        onChange={e =>
                                            setEditData(prev => ({
                                                ...prev,
                                                nameStudent: e.target.value
                                            }))
                                        }
                                    />
                                </Field>

                                <Field label="Data de Nascimento">
                                    <Input
                                        placeholder="DD/MM/AAAA"
                                        value={formatDatePtBr(editData.birth)}
                                        onChange={e => {
                                            const masked = maskDatePtBr(e.target.value)
                                            setEditData(prev => ({
                                                ...prev,
                                                // guarda ISO quando a data está completa; senão mantém o texto digitado
                                                birth: masked.length === 10 ? toIsoDate(masked) : masked
                                            }))
                                        }}
                                    />
                                </Field>

                                <Field label="Sexo">
                                    <Input
                                        value={editData.sexo ?? ''}
                                        onChange={e =>
                                            setEditData(prev => ({
                                                ...prev,
                                                sexo: e.target.value
                                            }))
                                        }
                                    />
                                </Field>

                                <Field label="Nacionalidade">
                                    <Input
                                        value={editData.nationality ?? ''}
                                        onChange={e =>
                                            setEditData(prev => ({
                                                ...prev,
                                                nationality: e.target.value
                                            }))
                                        }
                                    />
                                </Field>

                                <Field label="Estado">
                                    <Input
                                        value={editData.state ?? ''}
                                        onChange={e =>
                                            setEditData(prev => ({
                                                ...prev,
                                                state: e.target.value
                                            }))
                                        }
                                    />
                                </Field>

                                <Field label="Naturalidade">
                                    <Input
                                        value={editData.naturalness ?? ''}
                                        onChange={e =>
                                            setEditData(prev => ({
                                                ...prev,
                                                naturalness: e.target.value
                                            }))
                                        }
                                    />
                                </Field>

                                <Field label="Mínimo para promoção">
                                    <Input
                                        value={editData.averageGrade ?? ''}
                                        onChange={e =>
                                            setEditData(prev => ({
                                                ...prev,
                                                averageGrade: e.target.value
                                            }))
                                        }
                                    />
                                </Field>

                                <Field label="Dias Letivos Anuais">
                                    <Input
                                        type="number"
                                        value={editData.annualSchoolDays ?? ''}
                                        onChange={e =>
                                            setEditData(prev => ({
                                                ...prev,
                                                annualSchoolDays: e.target.value
                                            }))
                                        }
                                    />
                                </Field>

                                <Field label="Nome da Mãe">
                                    <Input
                                        value={editData.mothersName ?? ''}
                                        onChange={e =>
                                            setEditData(prev => ({
                                                ...prev,
                                                mothersName: e.target.value
                                            }))
                                        }
                                    />
                                </Field>

                                <Field label="Nome do Pai">
                                    <Input
                                        value={editData.fathersName ?? ''}
                                        onChange={e =>
                                            setEditData(prev => ({
                                                ...prev,
                                                fathersName: e.target.value
                                            }))
                                        }
                                    />
                                </Field>

                                <FullWidth>
                                    <Field label="Endereço">
                                        <Input
                                            value={editData.address ?? ''}
                                            onChange={e =>
                                                setEditData(prev => ({
                                                    ...prev,
                                                    address: e.target.value
                                                }))
                                            }
                                        />
                                    </Field>
                                </FullWidth>
                            </FormGrid>
                        </Section>

                        {/* ===== DADOS ESCOLARES ===== */}
                        <Section>
                            <SectionTitle>Dados Escolares</SectionTitle>

                            <FormGrid>
                                <Field label="Ano de Escolaridade / Série">
                                    <Input
                                        value={editData.serie ?? editData.idClass?.serie ?? ''}
                                        onChange={e =>
                                            setEditData(prev => ({
                                                ...prev,
                                                serie: e.target.value
                                            }))
                                        }
                                    />
                                </Field>

                                <Field label="Turma">
                                    <Input
                                        value={editData.nameClass ?? editData.idClass?.name ?? ''}
                                        onChange={e =>
                                            setEditData(prev => ({
                                                ...prev,
                                                nameClass: e.target.value
                                            }))
                                        }
                                    />
                                </Field>

                                <Field label="Turno">
                                    {(() => {
                                        const currentShift = editData.shift ?? editData.idClass?.shift ?? ''
                                        const padrao = ['MATUTINO', 'VESPERTINO', 'NOTURNO', 'INTEGRAL']
                                        // se o valor salvo não está na lista padrão, inclui como opção extra
                                        const foraPadrao = currentShift && !padrao.includes(currentShift)
                                        return (
                                            <Select
                                                value={currentShift}
                                                onChange={e =>
                                                    setEditData(prev => ({
                                                        ...prev,
                                                        shift: e.target.value
                                                    }))
                                                }
                                            >
                                                <option value="">Selecione</option>
                                                {foraPadrao && (
                                                    <option value={currentShift}>{currentShift}</option>
                                                )}
                                                <option value="MATUTINO">Matutino</option>
                                                <option value="VESPERTINO">Vespertino</option>
                                                <option value="NOTURNO">Noturno</option>
                                                <option value="INTEGRAL">Integral</option>
                                            </Select>
                                        )
                                    })()}
                                </Field>
                            </FormGrid>
                        </Section>

                        {/* ===== PERÍODOS ===== */}
                        <Section>
                            <SectionTitle>Períodos</SectionTitle>

                            {periodosEdicao.map((rc) => (
                                <PeriodCard key={rc._id ?? rc.bimonthly}>
                                    <PeriodTitle>{nomePeriodo(rc.bimonthly)}</PeriodTitle>

                                    {/* NOTAS */}
                                    <SubLabel>Notas por disciplina</SubLabel>
                                    <FormGrid>
                                        {matters.map(m => {
                                            const subjectName = m.name
                                            const value = rc.studentGrade?.[subjectName]?.total ?? ''

                                            return (
                                                <Field key={subjectName} label={subjectName}>
                                                    <Input
                                                        value={value}
                                                        onChange={(e) => {
                                                            const val = e.target.value
                                                            const rcId = rc._id ?? rc.bimonthly

                                                            setEditData(prev => {
                                                                const newReport = prev.reportCard.map(r => {
                                                                    const rId = r._id ?? r.bimonthly
                                                                    if (rId !== rcId) return r
                                                                    const grades = { ...(r.studentGrade || {}) }
                                                                    grades[subjectName] = {
                                                                        ...(grades[subjectName] || {}),
                                                                        total: val
                                                                    }
                                                                    return { ...r, studentGrade: grades }
                                                                })
                                                                return { ...prev, reportCard: newReport }
                                                            })
                                                        }}
                                                    />
                                                </Field>
                                            )
                                        })}
                                    </FormGrid>

                                    {/* FREQUÊNCIA — destaque */}
                                    <FreqStrip>

                                        <FreqItem>
                                            <FreqLabel $variant="faltas">Faltas</FreqLabel>
                                            <Input
                                                type="number"
                                                value={rc.frequencia?.totalFaltas ?? ''}
                                                onChange={(e) => {
                                                    const val = e.target.value
                                                    const rcId = rc._id ?? rc.bimonthly

                                                    setEditData(prev => {
                                                        const newReport = prev.reportCard.map(r => {
                                                            const rId = r._id ?? r.bimonthly
                                                            if (rId !== rcId) return r
                                                            return {
                                                                ...r,
                                                                frequencia: {
                                                                    ...r.frequencia,
                                                                    totalFaltas: val
                                                                }
                                                            }
                                                        })
                                                        return { ...prev, reportCard: newReport }
                                                    })
                                                }}
                                            />
                                        </FreqItem>

                                        <FreqItem>
                                            <FreqLabel $variant="dias">Dias Letivos</FreqLabel>
                                            <Input
                                                type="number"
                                                value={
                                                    (rc.id_iStQuarter ||
                                                        rc.id_iiNdQuarter ||
                                                        rc.id_iiiRdQuarter ||
                                                        rc.id_ivThQuarter)?.schoolDays?.length ?? ''
                                                }
                                                onChange={(e) => {
                                                    const val = e.target.value
                                                    const rcId = rc._id ?? rc.bimonthly

                                                    setEditData(prev => {
                                                        const newReport = prev.reportCard.map(r => {
                                                            const rId = r._id ?? r.bimonthly
                                                            if (rId !== rcId) return r
                                                            const rcEdit = { ...r }
                                                            setDiasLetivos(rcEdit, val)
                                                            return rcEdit
                                                        })
                                                        return { ...prev, reportCard: newReport }
                                                    })
                                                }}
                                            />
                                        </FreqItem>

                                    </FreqStrip>
                                </PeriodCard>
                            ))}
                        </Section>

                        {/* ===== RECUPERAÇÃO ===== */}
                        <Section>
                            <SectionTitle>Recuperação</SectionTitle>
                            <p style={{ margin: '0 0 10px', fontSize: 12.5, color: 'var(--text-muted, #5b6b72)' }}>
                                A recuperação final lançada pelo professor (aba Recuperação) é preenchida aqui automaticamente.
                                Se você alterar uma linha, ela passa a valer como preenchida à mão e não é mais trocada pelo sistema.
                            </p>

                            {editData.recovery?.map((rec, i) => (
                                <PeriodCard key={i}>
                                    {rec.auto === true && (
                                        <div style={{ fontSize: 11.5, fontWeight: 700, color: '#0891b2', marginBottom: 6 }}>
                                            🔄 Preenchido automaticamente pela recuperação final
                                        </div>
                                    )}

                                    <FormGrid>

                                        <Field label="Matéria">
                                            <Select
                                                value={rec.subject ?? ''}
                                                onChange={(e) => {
                                                    const val = e.target.value

                                                    setEditData(prev => {
                                                        const newRecovery = [...prev.recovery]

                                                        newRecovery[i] = {
                                                            ...newRecovery[i],
                                                            auto: false, // alterado à mão: passa a valer como manual
                                                            subject: val
                                                        }

                                                        return {
                                                            ...prev,
                                                            recovery: newRecovery
                                                        }
                                                    })
                                                }}
                                            >
                                                <option value="">Selecione</option>
                                                {matters.map(m => (
                                                    <option key={m._id} value={m.name}>{m.name}</option>
                                                ))}
                                            </Select>
                                        </Field>

                                        <Field label="Nota">
                                            <Input
                                                type="number"
                                                value={rec.grade ?? ''}
                                                onChange={(e) => {
                                                    const val = e.target.value

                                                    setEditData(prev => {
                                                        const newRecovery = [...prev.recovery]

                                                        newRecovery[i] = {
                                                            ...newRecovery[i],
                                                            auto: false, // alterado à mão: passa a valer como manual
                                                            grade: val
                                                        }

                                                        return {
                                                            ...prev,
                                                            recovery: newRecovery
                                                        }
                                                    })
                                                }}
                                            />
                                        </Field>

                                        <Field label="Carga Horária">
                                            <Input
                                                type="number"
                                                value={rec.workload ?? ''}
                                                onChange={(e) => {
                                                    const val = e.target.value

                                                    setEditData(prev => {
                                                        const newRecovery = [...prev.recovery]

                                                        newRecovery[i] = {
                                                            ...newRecovery[i],
                                                            auto: false, // alterado à mão: passa a valer como manual
                                                            workload: val
                                                        }

                                                        return {
                                                            ...prev,
                                                            recovery: newRecovery
                                                        }
                                                    })
                                                }}
                                            />
                                        </Field>

                                        <Field label="Faltas">
                                            <Input
                                                type="number"
                                                value={rec.absences ?? ''}
                                                onChange={(e) => {
                                                    const val = e.target.value

                                                    setEditData(prev => {
                                                        const newRecovery = [...prev.recovery]

                                                        newRecovery[i] = {
                                                            ...newRecovery[i],
                                                            auto: false, // alterado à mão: passa a valer como manual
                                                            absences: val
                                                        }

                                                        return {
                                                            ...prev,
                                                            recovery: newRecovery
                                                        }
                                                    })
                                                }}
                                            />
                                        </Field>

                                    </FormGrid>

                                    <Button
                                        variant="danger"
                                        style={{ marginTop: 10 }}
                                        onClick={() => {
                                            setEditData(prev => ({
                                                ...prev,
                                                recovery: prev.recovery.filter((_, index) => index !== i)
                                            }))
                                        }}
                                    >
                                        Remover
                                    </Button>

                                </PeriodCard>
                            ))}

                            <Button
                                onClick={() => {
                                    setEditData(prev => ({
                                        ...prev,
                                        recovery: [
                                            ...(prev.recovery || []),
                                            { subject: '', grade: '', workload: '', absences: '' }
                                        ]
                                    }))
                                }}
                            >
                                ➕ Adicionar Recuperação
                            </Button>
                        </Section>

                        {/* ===== TOTAL GERAL ===== */}
                        <Section>
                            <SectionTitle>Total Geral</SectionTitle>

                            <p style={{ margin: '0 0 10px', fontSize: 13, color: 'var(--text-muted, #666)' }}>
                                {periodosCompletos
                                    ? 'Todos os períodos estão completos: o total é calculado automaticamente. Preencha apenas se quiser substituir o valor calculado.'
                                    : `Faltam ${periodosFaltando} período(s): o total geral fica em branco na ficha. Preencha manualmente se necessário.`}
                                {' '}Formato: horas:minutos (ex.: 800:00). Deixe vazio para usar o cálculo automático.
                            </p>

                            <FormGrid>
                                <Field label="Carga Horária (Total Geral)">
                                    <Input
                                        inputMode="numeric"
                                        placeholder={totalCargaHorariaAuto !== '' ? `Automático: ${formatHoras(totalCargaHorariaAuto)}` : 'Ex.: 800:00'}
                                        value={editData.totalWorkloadManual ?? ''}
                                        onChange={(e) =>
                                            setEditData(prev => ({
                                                ...prev,
                                                totalWorkloadManual: e.target.value.replace(/[^\d:,.]/g, '')
                                            }))
                                        }
                                    />
                                </Field>

                                <Field label="Faltas em Horas (Total Geral)">
                                    <Input
                                        inputMode="numeric"
                                        placeholder={totalFaltasHorasAuto !== '' ? `Automático: ${formatHoras(totalFaltasHorasAuto)}` : 'Ex.: 12:00'}
                                        value={editData.totalAbsencesManual ?? ''}
                                        onChange={(e) =>
                                            setEditData(prev => ({
                                                ...prev,
                                                totalAbsencesManual: e.target.value.replace(/[^\d:,.]/g, '')
                                            }))
                                        }
                                    />
                                </Field>
                            </FormGrid>
                        </Section>

                        {/* ===== TOTAL GERAL — APROVEITAMENTO POR MATÉRIA ===== */}
                        {(() => {
                            // matérias que ainda não têm nota em todos os períodos
                            const materiasIncompletas = matters
                                .map(m => m.name)
                                .filter(nome => !temTodasNotas(periodosEdicao, nome, TOTAL_PERIODOS))
                            return (
                            <Section>
                                <SectionTitle>Total Geral — Aproveitamento por matéria</SectionTitle>

                                <p style={{ margin: '0 0 10px', fontSize: 13, color: 'var(--text-muted, #666)' }}>
                                    {materiasIncompletas.length > 0
                                        ? <>Sem nota em todos os {isTrimestral ? 'trimestres' : 'bimestres'}: <strong>{materiasIncompletas.join(', ')}</strong>. O total geral dessas matérias fica em branco na ficha. Preencha à mão ou use o botão para somar as notas dos períodos que o aluno já tem.</>
                                        : 'Todas as matérias têm nota em todos os períodos: o total geral é calculado automaticamente.'}
                                    {' '}Valores preenchidos aqui substituem o cálculo automático; deixe vazio para usar o automático.
                                </p>

                                <Actions style={{ justifyContent: 'flex-start', marginBottom: 12 }}>
                                    <Button
                                        type="button"
                                        onClick={() => {
                                            const calculado = {}
                                            matters.forEach(m => {
                                                calculado[m.name] = somaNotasDisponiveis(periodosEdicao, m.name, TOTAL_PERIODOS)
                                            })
                                            setEditData(prev => ({ ...prev, totalGradesManual: calculado }))
                                        }}
                                    >
                                        🧮 Calcular com os períodos disponíveis
                                    </Button>
                                    <Button
                                        type="button"
                                        onClick={() => setEditData(prev => ({ ...prev, totalGradesManual: {} }))}
                                    >
                                        Limpar
                                    </Button>
                                </Actions>

                                <FormGrid>
                                    {matters.map(m => (
                                        <Field key={m.name} label={m.name}>
                                            <Input
                                                inputMode="decimal"
                                                placeholder={somaNotasDisponiveis(periodosEdicao, m.name, TOTAL_PERIODOS) || 'Ex.: 18,5'}
                                                value={notaManual(editData.totalGradesManual, m.name)}
                                                onChange={(e) => {
                                                    const val = e.target.value.replace(/[^\d,.]/g, '')
                                                    setEditData(prev => {
                                                        const atual = { ...(prev.totalGradesManual || {}) }
                                                        const key = Object.keys(atual).find(k => norm(k) === norm(m.name)) || m.name
                                                        atual[key] = val
                                                        return { ...prev, totalGradesManual: atual }
                                                    })
                                                }}
                                            />
                                        </Field>
                                    ))}
                                </FormGrid>
                            </Section>
                            )
                        })()}

                        {/* ===== FINAL ===== */}
                        <Section>
                            <SectionTitle>Final</SectionTitle>

                            <FormGrid>

                                <Field label="Situação do Aluno">
                                    <Select
                                        value={editData.studentSituation ?? ''}
                                        onChange={(e) =>
                                            setEditData(prev => ({
                                                ...prev,
                                                studentSituation: e.target.value
                                            }))
                                        }
                                    >
                                        <option value="">Selecione</option>
                                        <option value="APROVADO">Aprovado</option>
                                        <option value="REPROVADO">Reprovado</option>
                                        <option value="TRANSFERIDO">Transferido</option>
                                        <option value="DESISTENTE">Desistente</option>
                                    </Select>
                                </Field>

                            </FormGrid>

                            <FullWidth style={{ marginTop: 12 }}>
                                <Field label="Observações (exibidas na coluna da tabela):">
                                    <TextArea
                                        style={{ minHeight: 100 }}
                                        maxLength={800}
                                        value={editData.observations ?? ''}
                                        onChange={(e) =>
                                            setEditData(prev => ({
                                                ...prev,
                                                // limite de 300 caracteres (guarda também contra colagem)
                                                observations: (e.target.value || '').slice(0, 800)
                                            }))
                                        }
                                    />
                                    <div style={{
                                        fontSize: 11,
                                        color: (editData.observations ?? '').length >= 800 ? '#c62828' : '#777',
                                        textAlign: 'right',
                                        marginTop: 4
                                    }}>
                                        {(editData.observations ?? '').length}/800
                                    </div>
                                </Field>
                            </FullWidth>

                            <FullWidth style={{ marginTop: 12 }}>
                                <Field label="Síntese do professor sobre os avanços e as dificuldades do aluno:">
                                    <TextArea
                                        style={{ minHeight: 100 }}
                                        value={editData.teachersSummaryOfTheStudent ?? ''}
                                        onChange={(e) =>
                                            setEditData(prev => ({
                                                ...prev,
                                                teachersSummaryOfTheStudent: e.target.value
                                            }))
                                        }
                                    />
                                </Field>
                            </FullWidth>
                        </Section>

                        {/* ===== BOTÕES ===== */}
                        <Actions>
                            <Button onClick={() => setIsEditing(false)}>
                                Cancelar
                            </Button>

                            <Button variant="primary" onClick={async () => {
                                try {
                                    const payload = {
                                        ...editData,
                                        birth: toIsoDate(editData.birth)
                                    }
                                    await UpdateAnnualForm(editData._id, payload)
                                    setIsEditing(false)

                                    const res = await GetStudentAnnualForm(id_student)
                                    setHistory(res.data)
                                } catch (err) {
                                    console.error(err)
                                    alert("Erro ao salvar")
                                }
                            }}>
                                💾 Salvar alterações
                            </Button>
                        </Actions>

                    </EditModal>
                </Overlay>
            )}

            {showEmptyWarning && (
                <Overlay onClick={() => setShowEmptyWarning(false)}>
                    <Modal
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            maxWidth: 520,
                            width: '90%',
                            padding: '28px 32px',
                            borderRadius: 12,
                            textAlign: 'center',
                        }}
                    >
                        {/* Ícone */}
                        <div style={{ fontSize: 42, marginBottom: 10 }}>⚠️</div>

                        {/* Título */}
                        <h2 style={{
                            margin: '0 0 12px',
                            fontSize: 20,
                            color: 'var(--text, var(--text-muted))'
                        }}>
                            Nenhum dado disponível
                        </h2>

                        {/* Texto */}
                        <p style={{
                            fontSize: 14,
                            lineHeight: 1.7,
                            color: 'var(--text, var(--text-muted))',
                            marginBottom: 20,
                        }}>
                            Este aluno ainda não possui dados consolidados no diário da turma.
                            <br /><br />
                            Para que as informações apareçam aqui, é necessário que o professor:
                            <br />
                            • Atualize os dados do aluno até o último dia em que ele frequentou as aulas<br />
                            • No diário da turma, feche os períodos em que o aluno estudou
                            <br /><br />
                            Após o fechamento, os dados serão automaticamente adicionados à ficha individual do aluno.
                            Os períodos poderão ser reabertos posteriormente, se necessário.</p>

                        {/* Alerta: aluno removido da turma antes do fechamento dos diários */}
                        <div
                            role="alert"
                            style={{
                                textAlign: 'left',
                                background: 'var(--red-soft, #fdecea)',
                                border: '2px solid var(--red, #d32f2f)',
                                borderLeftWidth: 6,
                                borderRadius: 10,
                                padding: '14px 16px',
                                marginBottom: 20,
                                fontSize: 14,
                                lineHeight: 1.6,
                                color: 'var(--text, #16323b)',
                            }}
                        >
                            <strong style={{ display: 'block', color: 'var(--red, #d32f2f)', fontSize: 15, marginBottom: 6 }}>
                                🚨 Atenção: o aluno foi removido, remanejado ou transferido da turma?
                            </strong>
                            Se o aluno foi <strong>removido, remanejado ou transferido da turma antes de fechar os diários</strong> de todos os períodos
                            em que ele estudou, os dados dele <strong>não chegam</strong> à ficha individual.
                            <br /><br />
                            <strong>Como resolver:</strong>
                            <br />
                            1. <strong>Retorne o aluno para a turma antiga</strong>;
                            <br />
                            2. <strong>Feche os diários</strong> dos períodos em que ele estudou.
                            {' '}Se esses diários <strong>já estiverem fechados</strong>, <strong>reabra e feche novamente</strong>
                            {' '}com o aluno ainda na turma, para que os dados dele sejam consolidados;
                            <br />
                            3. Confira se os dados apareceram na ficha individual e, depois disso, remova, remaneje ou transfira o aluno novamente, se necessário.
                        </div>

                        {/* Botão */}
                        <Actions style={{
                            justifyContent: 'center'
                        }}>
                            <Button
                                onClick={() => setShowEmptyWarning(false)}
                                style={{
                                    padding: '10px 20px',
                                    fontSize: 14,
                                    borderRadius: 8,
                                    background: '#2e7d32',
                                }}
                            >
                                Entendi
                            </Button>
                        </Actions>
                    </Modal>
                </Overlay>
            )}

            {showDeleteConfirm && (
                <Overlay onClick={() => !deleting && setShowDeleteConfirm(false)}>
                    <Modal
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            maxWidth: 520,
                            width: '90%',
                            padding: '28px 32px',
                            borderRadius: 12,
                            textAlign: 'center',
                        }}
                    >
                        <div style={{ fontSize: 42, marginBottom: 10 }}>🗑️</div>

                        <h2 style={{
                            margin: '0 0 12px',
                            fontSize: 20,
                            color: 'var(--text, var(--text-muted))'
                        }}>
                            Apagar ficha individual?
                        </h2>

                        <p style={{
                            fontSize: 14,
                            lineHeight: 1.7,
                            color: 'var(--text, var(--text-muted))',
                            marginBottom: 20,
                        }}>
                            Tem certeza de que deseja apagar esta ficha individual?
                            <br /><br />
                            Se precisar da ficha depois, os dados terão que ser adicionados novamente.
                        </p>

                        <Actions style={{ justifyContent: 'center' }}>
                            <Button
                                onClick={() => setShowDeleteConfirm(false)}
                                disabled={deleting}
                                style={{
                                    padding: '10px 20px',
                                    fontSize: 14,
                                    borderRadius: 8,
                                    background: '#9e9e9e',
                                }}
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={handleDelete}
                                disabled={deleting}
                                style={{
                                    padding: '10px 20px',
                                    fontSize: 14,
                                    borderRadius: 8,
                                    background: '#c62828',
                                }}
                            >
                                {deleting ? 'Apagando...' : 'Apagar ficha'}
                            </Button>
                        </Actions>
                    </Modal>
                </Overlay>
            )}

        </FichaContainer>

    )
}

export default FichaIndividual